import './register.scss';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
import apiRequest from '../../lib/apiRequest';

function Register() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    const formData = new FormData(e.target);

    const username = formData.get('username');
    const email = formData.get('email');
    const password = formData.get('password');

    if (!agreeToTerms) {
      setError('You must agree to the terms and conditions.');
      setIsLoading(false);
      return;
    }

    try {
      const res = await apiRequest.post('/auth/register', {
        username,
        email,
        password,
      });

      navigate('/login');
    } catch (err) {
      setError(err.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    setAgreeToTerms(e.target.checked);
  };

  return (
    <div className="registerPage">
      <div className="formContainer">
        <form onSubmit={handleSubmit}>
          <h1>Create an Account</h1>
          <input name="username" type="text" placeholder="Username" />
          <input name="email" type="text" placeholder="Email" />
          <input name="password" type="password" placeholder="Password" />
          <div className="termsContainer">
            <input
              type="checkbox"
              name="terms"
              checked={agreeToTerms}
              onChange={handleCheckboxChange}
            />
            <label>
              I agree to the{' '}
              <Link to="/rules" target="_blank">
                Terms and Conditions
              </Link>
            </label>
          </div>
          <button disabled={isLoading}>Register</button>
          {error && <span>{error}</span>}
          <Link to="/login">Do you have an account?</Link>
        </form>
      </div>
    </div>
  );
}

export default Register;
